import { scrollToElement } from "./scroll-to-element";

export default function ScrollToHash() {
  const hash = window.location.hash;
  const richTextBlocks = document.querySelectorAll<HTMLDivElement>(".rich-text");

  const handleScrollToHash = (id: string) => {
    if (id) {
      scrollToElement(id, { smooth: true, gap: 16 });
    }
  };

  if (hash) {
    window.addEventListener("load", () => {
      setTimeout(() => {
        handleScrollToHash(hash);
      }, 100);
    });
  }

  if (richTextBlocks && richTextBlocks.length > 0) {
    richTextBlocks.forEach((block) => {
      const anchorLinks = block.querySelectorAll<HTMLAnchorElement>('a[href^="#"]');

      if (anchorLinks && anchorLinks.length > 0) {
        anchorLinks.forEach((link) => {
          link.addEventListener("click", (e) => {
            const scrollId = link.getAttribute("href");

            if (scrollId) {
              e.preventDefault();
              handleScrollToHash(scrollId);
            }
          });
        });
      }
    });
  }
}
